import React from 'react'
import Layout from '../components/layouts/Layout'
import ComingSoon from '../modules/sections/about/ComingSoon'
import AboutHero from "../modules/sections/about/AboutHero"
export const AboutUs = () => {
  return (
    <div>
      <Layout>
        <AboutHero></AboutHero>
      </Layout>

    </div>
  )
}
